import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { queryNoticeDetail } from "utils/api";
import style from "./index.module.scss";
import useStores from "stores";
import Utils from 'utils/utils.js';

const App = () => {
  const { loginStore } = useStores();
  const [noticeContent, setNoticeContent] = useState({});
  const [title, setTitle] = useState('');
  const { noticeid } = useParams();

  useEffect(() => {
    queryNoticeDetail({
      noticeId: noticeid,
    }).then((res) => {
      if (res.data.success) {

        setTitle(res.data.result.noticeTitle)
        if(Utils.getQueryVariable('k')){
          res.data.result.bigContent = Utils.matchSearchKeys(res.data.result.bigContent,'str')
          res.data.result.noticeTitle = Utils.matchSearchKeys(res.data.result.noticeTitle,'str',false)
         }

        setNoticeContent(res.data.result);
      }
    });
  }, [noticeid]);

  return (
    <div className={`${style.noticeDetailWrapper}`}>
      <div className={`${style.tipHeaderContainer}`}>
        <div className={`${style.content}`}>
          <div className={`${style.left}`}>
            <i></i>
            <span>消息公告</span>
          </div>
          <div className={`${style.right}`}>
            <span>消息公告</span>
            <span className={`${style.line}`}>/</span>
            <span className={`${style.gray}`}>系统公告</span>
            <span className={`${style.line}`}>/</span>
            <span>{title}</span>
          </div>
        </div>
      </div>
      <div className={`${style.noticeDetail}`}>
        <div className={`${style.detailContent}`}>
          <div className={`${style.noticeNavContainer}`}>
            <div className={`${style.title}`}>公告类型</div>
            <div className={`${style.navList}`}>
              <div className={`${style.item} ${style.cur}`}>
                <Link
                  to="/notice"
                  clstag="pageclick|keycount|VopOpenIndex_1602911919488|9"
                >
                  系统公告
                </Link>
              </div>
              {loginStore.isLogin ? (
                <div className={`${style.item}`}>
                  <Link to="/message">消息通知</Link>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className={`${style.noticeDetailContainer}`}>
            <div className={`${style.title}`} dangerouslySetInnerHTML={{ __html: noticeContent.noticeTitle }}></div>
            <div className={`${style.time}`}>
              发布于：{noticeContent.updateTime}
            </div>
            <div
              className={`${style.noticeContent}`}
              dangerouslySetInnerHTML={{ __html: noticeContent.bigContent }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
